import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, MenuItem, Stack } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import React from "react";
import "./UploadModal.css";
import DatePicker from "@mui/lab/DatePicker";

export const FormDialog = (props) => {
  const {
    isOpen,
    handleClose,
    postVideoData,
    handleChange,
    handleSubmit,
    handleCancel,
  } = props;

  const allGenres = ["Education", "Sports", "Lifestyle"];

  const ageArray = ["7+", "12+", "16+", "18+"];

  return (
    <div>
      <Dialog open={isOpen} onClose={handleClose} sx={{ color: "#383838" }}>
        <Stack
          direction="rew"
          alignItems="center"
          justifyContent="space-between"
        >
          <DialogTitle sx={{ fontWeight: "400" }}>Upload Video</DialogTitle>
          <Box paddingRight="24px" color="#FFFF">
            <span onClick={() => handleClose()} style={{ cursor: "pointer" }}>
              <CloseIcon />
            </span>
          </Box>
        </Stack>
        <DialogContent>
          <Stack spacing={2} paddingBottom={2} direction="column">
            <TextField
              id="outlined-helperText"
              label="Video Link"
              name="videoLink"
              value={postVideoData.videoLink}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
              helperText="This link will be used to derive the video"
              fullWidth
            />
            <TextField
              id="outlined-helperText"
              label="Thumbnail Image Link"
              name="previewImage"
              value={postVideoData.previewImage}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
              helperText="This link will be used to preview the thumbnail image"
              fullWidth
            />
            <TextField
              id="outlined-helperText"
              label="Title"
              name="title"
              value={postVideoData.title}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
              helperText="The title will be the representative text for video"
              fullWidth
            />
            <TextField
              id="outlined-select"
              select
              label="Genre"
              name="genre"
              value={postVideoData.genre}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
              helperText="Genre will help in categorizing your videos"
              fullWidth
            >
              {allGenres.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              id="outlined-helperText"
              select
              label="Suitable age group for the clip"
              name="contentRating"
              value={postVideoData.contentRating}
              onChange={(e) => handleChange(e.target.name, e.target.value)}
              helperText="This will be used to filter videos on age group suitability"
              fullWidth
            >
              {ageArray.map((item) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </TextField>
            <DatePicker
              label="Release date"
              helperText="This will be used to sort videos"
              value={postVideoData.releaseDate}
              onChange={(newValue) => {
                handleChange("releaseDate", newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
        
            />
          </Stack>
        </DialogContent>
        <Stack
          direction="row"
          justifyContent="flex-start"
          paddingBottom={2}
          px={3}
        >
          <Button
            variant="contained"
            onClick={() => handleSubmit()}
            sx={{
              backgroundColor: "#EE1520",
              fontSize: "13px",
              ":hover": {
                backgroundColor: "#EE1520",
              },
            }}
          >
            UPLOAD VIDEO
          </Button>
          <Box onClick={handleCancel} className="cancel">
            CANCEL
          </Box>
        </Stack>
      </Dialog>
    </div>
  );
};
